import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilityHelper } from '../helpers/utilityHelper';
import { AuthenticationHelper } from '../helpers/authenticationHelper';

export const UnmatchedMenteeGuard: CanActivateFn = () => {

  const utility = inject(UtilityHelper);
  const authService = inject(AuthenticationHelper);
  const router = inject(Router);

  const isLoggedIn = authService.isLoggedIn();
  const role = utility.getItem('role');
  const isUnmatched = utility.getItem('isMenteeMatched') === 'unmatched' || utility.getItem('isMenteeMatched') !== 'matched';

  if (isLoggedIn && role === 'mentee' && isUnmatched) {
    return true;
  }

  return router.createUrlTree(['']);
};